import { INSTAGRAM_CAROUSEL_MIN_ITEMS } from './instagram.const';
function mirrorLegacyFromFirst(first) {
    if (first.type === 'image') {
        return { imageUrl: first.url, imageAttachmentId: first.attachmentId };
    }
    return { imageUrl: null, imageAttachmentId: null };
}
export function buildCarouselContentPatch(mediaItems) {
    if (!Array.isArray(mediaItems) || mediaItems.length < INSTAGRAM_CAROUSEL_MIN_ITEMS)
        return null;
    return {
        mediaItems,
        ...mirrorLegacyFromFirst(mediaItems[0]),
    };
}
export function applyEditedCarouselSlide(existing, edit) {
    if (existing.length === 0)
        return null;
    let targetIndex = edit.replacedAttachmentId
        ? existing.findIndex(item => item.attachmentId === edit.replacedAttachmentId)
        : -1;
    if (targetIndex === -1) {
        if (edit.slideIndex < 0 || edit.slideIndex >= existing.length)
            return null;
        targetIndex = edit.slideIndex;
    }
    const updated = existing.slice();
    updated[targetIndex] = { ...updated[targetIndex], ...edit.mediaItem };
    return {
        mediaItems: updated,
        ...mirrorLegacyFromFirst(updated[0]),
    };
}
//# sourceMappingURL=instagram-carousel-utils.js.map